import { Home } from '@sales-app/types/Home'
import { Property } from '@sales-app/types/Property'

import { HomesAPI_Data, Property_API_Response } from '../GeoLocation/GeoLocation'

export namespace DisplayCity {
  export namespace GET_HOMES {
    export type Response = Homes_GET_RESPONSE
    export type Error = unknown
  }

  export namespace GET_PROPERTIES {
    export type Response = Property_API_Response
    export type Error = unknown
  }

  export function getHomes(citySlug: string | undefined) {
    return { url: `/api/v1/display_cities/${citySlug}.json` }
  }

  export function getProperties(citySlug: string | undefined) {
    return { url: `/api/v1/display_cities/${citySlug}/properties.json` }
  }
}

export interface Homes_GET_RESPONSE {
  data: FurnishedMarketAPI_Data
}

export interface FurnishedMarketAPI_Data extends HomesAPI_Data {
  display_city?: City
  filters: {
    amenities: _MarketFilterAmenities[]
    bedrooms: _MarketFilterBedrooms[]
    sorting: _MarketFilterSorting[]
  }

  flexible_move_in?: {
    homes: Home[]
    homes_count: number
    move_in: string
    move_out: string
    properties: Property[]
    total_homes: number
  }
  homes?: Home[]
  market: MarketDetails
  special_offer?: {
    amount: string
    claim_copy: string
    copy: string
    id: number
    offer: string
    valid_for_months: number
  }
  state: string
}

export interface City {
  active_short_term_search_page: boolean
  active_standby_search_page: boolean
  id: number
  market_slug?: string
  name: string
  region: {
    abbreviation: string
    name: string
  }
  search_term?: string
  slug: string
}

export interface _MarketFilterAmenities {
  id: string
  title: string
}
export interface _MarketFilterBedrooms {
  id: string
  title: string
}
export interface _MarketFilterSorting {
  id: string
  title: string
}

export interface DisplayCity extends City {
  state: string
}

export interface MarketDetails extends DisplayCity {
  image_url: string
}

export type HomeGroups = (MainHomeGroup | AvailableInFutureHomeGroup)[]

export interface MainHomeGroup {
  homes: Home[]
  key: 'main' | 'on_demand' | 'hot'
  title: 'Main' | 'On Demand' | 'hot'
}

export interface AvailableInFutureHomeGroup {
  homes: Home[]
  key: 'available_in_the_future'
  title: 'Available in the future'
}
